import React, { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';

/**
 * Floating "Terug naar boven" knop — verschijnt na 300px scroll.
 *
 * Positionering: stack BOVEN de FAQ help-knop (`floating-help-btn`):
 *  - mobiel: bottom-36 right-4 (FAQ zit op bottom-24 → +48px stack-ruimte)
 *  - desktop: bottom-20 right-6 (FAQ zit op bottom-6 → +56px stack-ruimte)
 */
const ScrollToTopButton = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 300);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label="Terug naar boven"
      data-testid="scroll-to-top-btn"
      className="fixed bottom-36 right-4 md:bottom-20 md:right-6 z-[9998] w-10 h-10 rounded-full bg-white text-hoi-blue border border-gray-200 shadow-lg hover:shadow-xl hover:scale-105 active:scale-95 transition-all flex items-center justify-center"
    >
      <ArrowUp className="w-5 h-5" aria-hidden="true" />
    </button>
  );
};

export default ScrollToTopButton;
